import { render, staticRenderFns } from "./EntityActivityUserTable.vue?vue&type=template&id=190fa965"
import script from "./EntityActivityUserTable.vue?vue&type=script&lang=js"
export * from "./EntityActivityUserTable.vue?vue&type=script&lang=js"
import style0 from "./EntityActivityUserTable.vue?vue&type=style&index=0&id=190fa965&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports